import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import useTemplateSend from '../../hooks/useTemplateSend';
import useTemplateSendDialog from '../../hooks/useTemplateSendDialog';
import useTemplateSx from '../../hooks/useTemplateSx';
import { Dialog } from '../../../../components/ui';
import TemplateSendBulkPanel from './TemplateSendBulkPanel';
import LeanBulkSendPanel from './LeanBulkSendPanel';
import { USE_LEAN_BULK_SEND } from '../../constants/bulkSendConfig';
import TemplateSendPreview from './TemplateSendPreview';
import TemplateSendSinglePanel from './TemplateSendSinglePanel';

function TemplateSendDialogContent({ template, onClose }) {
  const styles = useTemplateSx();
  const send = useTemplateSend({ template, onClose });
  const [tab, setTab] = useState(0);

  return (
    <>
      <Tabs
        value={tab}
        onChange={(_event, value) => setTab(value)}
        sx={styles.sendDialogTabs}
      >
        <Tab label="Single Send" />
        <Tab label="Bulk Send" />
      </Tabs>

      {tab === 0 ? (
        <TemplateSendSinglePanel send={send} template={template} onClose={onClose} />
      ) : (
        <Box sx={styles.sendDialogGrid}>
          {USE_LEAN_BULK_SEND ? <LeanBulkSendPanel template={template} /> : <TemplateSendBulkPanel send={send} />}
          <TemplateSendPreview template={template} />
        </Box>
      )}
    </>
  );
}

export default function TemplateSendDialog() {
  const { open, template, closeSendDialog } = useTemplateSendDialog();

  return (
    <Dialog open={open} onClose={closeSendDialog} title="Send Template" maxWidth="md">
      {open && template ? (
        <TemplateSendDialogContent
          key={`${template.name}-${template.bot_number}`}
          template={template}
          onClose={closeSendDialog}
        />
      ) : null}
    </Dialog>
  );
}
